import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API } from "../App";

const LeistungenPage = () => {
  const [services, setServices] = useState([]);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const res = await axios.get(`${API}/services`);
        setServices([...(res.data || [])].sort((a, b) => (a.order || 0) - (b.order || 0)));
      } catch (error) {
        console.error("Error fetching services:", error);
      }
    };
    fetchServices();
  }, []);

  return (
    <div data-testid="leistungen-page">
      {/* Hero Section */}
      <section className="relative py-24" style={{ background: 'linear-gradient(135deg, #0A2A43 0%, #0A2A43 50%, #4a1a2a 85%, #6b1f2f 100%)' }}>
        <div className="relative max-w-7xl mx-auto px-4 md:px-8 lg:px-16 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4 font-barlow italic animate-on-load animate-fade-in-down">
            Unsere Leistungen
          </h1>
          <p className="text-white/80 text-lg max-w-2xl mx-auto animate-on-load animate-fade-in-up animation-delay-300">
            Professioneller Betonbau und Rohbauarbeiten aus Meisterhand – für private und gewerbliche Bauvorhaben.
          </p>
        </div>
      </section>

      {/* Services List */}
      <section className="section-padding bg-white">
        <div className="max-w-7xl mx-auto">
          {services.map((service, index) => (
            <div
              key={service.id}
              className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20 last:mb-0 ${
                index % 2 === 1 ? "lg:flex-row-reverse" : ""
              }`}
              data-testid={`service-detail-${service.slug}`}
            >
              <div className={index % 2 === 1 ? "lg:order-2" : ""}>
                <div className="relative">
                  <img
                    src={service.image_url}
                    alt={service.name}
                    className="w-full aspect-[4/3] object-cover rounded-sm shadow-lg"
                  />
                  <div className="absolute -bottom-4 -right-4 bg-[#D32F2F] text-white px-6 py-3 rounded-sm font-barlow font-bold">
                    {service.name}
                  </div>
                </div>
              </div>
              <div className={index % 2 === 1 ? "lg:order-1" : ""}>
                <span className="text-[#D32F2F] font-semibold text-sm uppercase tracking-wider mb-2 block">
                  Leistung #{index + 1}
                </span>
                <h2 className="text-3xl font-bold text-[#0A2A43] mb-4 font-barlow">
                  {service.name}
                </h2>
                <p className="text-[#475569] leading-relaxed mb-6">
                  {service.full_description}
                </p>
                {service.benefits && service.benefits.length > 0 && (
                  <div className="mb-6">
                    <h4 className="font-semibold text-[#0A2A43] mb-3">Ihre Vorteile:</h4>
                    <ul className="space-y-2">
                      {service.benefits.map((benefit) => (
                        <li key={`${service.id}-${benefit}`} className="flex items-center gap-3 text-[#475569]">
                          <svg className="w-5 h-5 text-[#D32F2F] flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                          </svg>
                          {benefit}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
                <Link to="/kontakt" className="btn-primary" data-testid={`service-cta-${service.slug}`}>
                  Angebot anfordern
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-[#F2F2F2]">
        <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-16 text-center">
          <h2 className="text-3xl font-bold text-[#0A2A43] mb-4 font-barlow">
            Bereit für Ihr Projekt?
          </h2>
          <p className="text-[#475569] mb-8 max-w-2xl mx-auto">
            Kontaktieren Sie uns für eine kostenlose und unverbindliche Beratung. Wir freuen uns darauf, Ihr Bauvorhaben zu realisieren.
          </p>
          <Link to="/kontakt" className="btn-primary" data-testid="leistungen-cta">
            Jetzt Kontakt aufnehmen
          </Link>
        </div>
      </section>
    </div>
  );
};

export default LeistungenPage;
